export function isObject(element: any): element is object {
  return !!element && typeof element === 'object' && !Array.isArray(element);
}
